import './App.css';
import { useEffect, useState } from 'react';
import TotemStanding from './TotemStanding';

import img_money from './money.png';
import PageMarketingV2MonetizeOffer from './PageMarketingV2MonetizeOffer';

function PageMarketingV2Monetize() {
    const [step, setStep] = useState('offer');
    const [t, setT] = useState(0);
    const [acceptedOffer, setAcceptedOffer] = useState(null);
    const [totalEarnings, setTotalEarnings] = useState(0);

    const offers = [
        {
            creativeURL: 'https://adtangs.fra1.digitaloceanspaces.com/7d8edfbf-d9a4-4921-8f84-d146ffc67759.webp',
            price: (Math.random() * 10).toFixed(2),
            author: {
                name: 'Oranges Shop',
                url: 'https://pngfre.com/wp-content/uploads/orange-69.png',
            },
        },
        {
            creativeURL: 'https://adtangs.fra1.digitaloceanspaces.com/bd67e899-7eaa-46ef-b687-e694caff2618.jpg',
            price: (Math.random() * 10).toFixed(2),
            author: {
                name: 'Christmas Market',
                url: 'https://icon-library.com/images/2018/198839_merry-christmas-christmas-wreath-merry-christmas-transparent-png.png',
            },
        },
        {
            creativeURL: 'https://media.post.rvohealth.io/wp-content/uploads/2020/09/health-benefits-of-apples-732x549-thumbnail-732x549.jpg',
            price: (Math.random() * 10).toFixed(2),
            author: {
                name: 'Apples Producer',
                url: 'https://w7.pngwing.com/pngs/474/306/png-transparent-apple-teacher-cartoon-apple.png',
            }
        },
        {
            creativeURL: 'https://d1mo5ln9tjltxq.cloudfront.net/-/media/images/categorycarousels/subcat_trail_c23.ashx?mh=1920&mw=2560&hash=BB604D200BA83F1EF516BAF2D9468AF8',
            price: (Math.random() * 10).toFixed(2),
            author: {
                name: 'Traditional Bikes',
                url: 'https://toppng.com/uploads/preview/riding-a-bike-cartoon-transparent-11549743672b7ibkhdonf.png',
            }
        }

    ]

    const [offer, setOffer] = useState(getRandomOffer());

    function getRandomOffer() {
        return offers[Math.floor(Math.random() * offers.length)];
    }

    function acceptOffer() {
        setAcceptedOffer(offer);
        setTotalEarnings(Number(totalEarnings) + Number(offer.price));
        declineOffer();
    }

    function declineOffer() {
        setStep('loading');
        setOffer(getRandomOffer());
        setTimeout(
            () => {
                setT(0);
                setStep('offer');
            },
            1000,
        )
    }

    useEffect(
        () => {
            setTimeout(
                () => {
                    var new_t = t + 1;
                    if (new_t > 99) {
                        new_t = 0;
                        declineOffer();
                    }

                    setT(new_t);
                },
                200,
            )
        },
        [t],
    )

    return (
        <div
            align='center'
            style={{ marginBottom: '4em' }}
        >
            <div className='mk2-title'>
                Monetize
            </div>
            <div
                style={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '1em',
                }}>
                <TotemStanding
                    creativeURL={acceptedOffer?.creativeURL}
                    creativeExt='jpg'
                />
                <div
                    className='mk2-subtitle-small'
                >
                    <div>
                        <b>Accept</b> advertising offers to transform your screens into profitable surfaces.
                    </div>
                    <div style={{ marginTop: '0.5em' }}>
                        <b>Decline</b> based on your own criteria.
                    </div>
                    <div
                        className='mk2-subtitle'
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginTop: '1em',
                        }}>
                        <div>
                            <img src={img_money} width={32} />
                        </div>
                        <div>
                            <b>
                                {(totalEarnings).toFixed(2)}&nbsp;EUR
                            </b>
                        </div>
                    </div>
                    <div className='mk2-mobile-hidden'>
                        <PageMarketingV2MonetizeOffer
                            t={t}
                            step={step}
                            setStep={setStep}
                            offer={offer}
                            acceptOffer={acceptOffer}
                            declineOffer={declineOffer}
                        />
                    </div>
                </div>
            </div>
            <div className='mk2-mobile-only'>
                <PageMarketingV2MonetizeOffer
                    t={t}
                    step={step}
                    setStep={setStep}
                    offer={offer}
                    acceptOffer={acceptOffer}
                    declineOffer={declineOffer}
                />
            </div>
        </div>
    );
}

export default PageMarketingV2Monetize;